/**
 * Geolocation
 * @typedef  {Object} Geolocation
 * @property {Object} coords
 * @property {String} coords.latitude
 * @property {String} coords.longitude
 */

/**
 * Get geolocation
 * @return {Object}
 * @return {Promise.<Geolocation>}
 */
function _getLocation() {
    return new Promise(function(resolve, reject) {
        if (window.navigator && window.navigator.geolocation) {
            window.navigator.geolocation.getCurrentPosition(resolve, reject);
        } else {
            reject('Geolocation is not supported.');
        }
    });
}

module.exports = {
    getLocation: _getLocation
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/geolocation-api/geolocation-api.js
// module id = 135
// module chunks = 0 1 16 24 25